import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';
import { MainContainer } from '../../styles/styles';
import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import ActionButton from '../../presentation/components/ActionButton/ActionButton';

const PageNotFound: React.FC = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleGoBackHome = () => {
    navigate('/');
  };

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.pagenotfound_title)} />
      <p>{t(TranslationKeys.pagenotfound_message)}</p>
      <br />
      <div style={{ textAlign: 'left' }}>
        <ActionButton
          variant="link-button"
          buttonText={t(TranslationKeys.pagenotfound_link_text)}
          onClickAction={handleGoBackHome}
        />
      </div>
    </MainContainer>
  );
};

export default PageNotFound;
